(function () {

    "use strict";

    angular
        .module("components")
        .component("hTabItemComponent", {
            controller: TabItemComponent,
            transclude: true,
            require: {
                tabParent: '^hTabsBarComponent'
            },
            bindings: {
                name: '@',
                id: '@',
                index: '@',
                icon: '@',
                tooltipIcon: '@',
                tooltipMessage: '@',
                showTooltip: '@',
                coloredTab: '@',
                subInfo: '@',
                subName: '<',
                tabClass: '<'
            },
            controllerAs: 'hTabItemComponent',
            templateUrl: '../hmodules/components/h-tabs/tab-item/tab-item.component.html'
        });

    TabItemComponent.$inject = ['$element'];

    function TabItemComponent($element) {

        var self = this;
        var isDestroyed = false;
        var tabItem = null;

        self.$onChanges = function (changesObj) {
            if (tabItem && changesObj.subInfo && changesObj.subInfo.currentValue !== changesObj.subInfo.previousValue) {
                tabItem.subInfo = changesObj.subInfo.currentValue;
            }

            if (tabItem) {
                tabItem.subName = self.subName;
                tabItem.tabClass = self.tabClass;
            }
        };

        self.$onInit = function () {
            tabItem = {
                name: self.name,
                id: self.id,
                index: self.index,
                subName: self.subName,
                tabClass: self.tabClass
            };

            if (self.subInfo) {
                tabItem.subInfo = self.subInfo;
            }

            if (self.icon) {
                tabItem.icon = self.icon;
            }
            if (self.showTooltip) {
                tabItem.showTooltip = self.showTooltip;
            }
            if (self.tooltipIcon) {
                tabItem.tooltipIcon = self.tooltipIcon;
            }
            if (self.tooltipMessage) {
                tabItem.tooltipMessage = self.tooltipMessage;
            }
            if (self.coloredTab) {
                tabItem.coloredTab = self.coloredTab;
            }

            self.tabParent.addNewTabItem(tabItem);
        };

        self.$postLink = function () {};

        /**
         * Make sure to destroy every not needed attached things
         */
        self.$onDestroy = function () {
            if (!isDestroyed) {
                self.tabParent.removeTab(self.id);
            }
        };

        /**
         * This need to clear data when the element removed from dom
         */
        $element.on('$destroy', function () {
            self.$onDestroy();
        });
    }

})();
